import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { ClickTapDirective } from '@celum/ng2base/directives';

@Component({
  selector: 'celum-list-infinite-scroll-wrapper',
  templateUrl: './infinite-scroll-list-wrapper.component.html',
  styleUrls: ['./infinite-scroll-list-wrapper.component.less'],
  imports: [InfiniteScrollModule, ClickTapDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class InfiniteScrollListWrapperComponent {
  @Input() public fromRoot: boolean;

  @Output() public readonly onEmptySpaceClick = new EventEmitter<Event>();
  @Output() public readonly onContextMenu = new EventEmitter<MouseEvent>();
  @Output() public readonly onScroll = new EventEmitter<boolean>();

  @HostBinding('class.infinite-scroll-list-wrapper') public hostCls = true;
}
